import viewService from "@/services/viewService";
import EntityService from "@/services/entityService";

const finMovService = new EntityService("FinMov");

const toNumber = (valor) => {
  const numero = Number(valor);
  return Number.isFinite(numero) ? numero : 0;
};

const possuiValor = (valor) => {
  if (valor === null || valor === undefined) return false;
  if (typeof valor === "string") return valor.trim() !== "";
  return true;
};

const resolverTipoMovimento = (linha = {}) => {
  const ehContaAPagar = [
    linha.contaAPagar,
    linha.contasAPagar,
    linha.conta_a_pagar,
    linha.payableAccount
  ].some(possuiValor);

  const ehContaAReceber = [
    linha.contaAReceber,
    linha.contasAReceber,
    linha.conta_a_receber,
    linha.receivableAccount
  ].some(possuiValor);

  if (ehContaAPagar && !ehContaAReceber) return "debito";
  if (ehContaAReceber && !ehContaAPagar) return "credito";

  const valorMovimento = toNumber(linha.valorMovimento || linha.valor || 0);
  return valorMovimento < 0 ? "debito" : "credito";
};

const normalizarLinha = (linha = {}) => {
  const valorMovimento = Math.abs(toNumber(linha.valorMovimento || linha.valor || 0));
  const tipoMovimento = resolverTipoMovimento(linha);
  const valorMenos = tipoMovimento === "debito" ? valorMovimento : 0;
  const valorMais = tipoMovimento === "credito" ? valorMovimento : 0;

  return {
    data: linha.dataMovimento || linha.data || null,
    informacoes: linha.descricao || linha.informacoes || "-",
    fornecedor: linha.fornecedorNome || linha.fornecedor || "-",
    valorMenos,
    valorMais,
    saldo: toNumber(linha.saldo || linha.valorSaldo || 0),
    banco: linha.contaFinanceiraNome || linha.banco || "-"
  };
};

const extrairLista = (response) => {
  const lista = response?.data?.data?.data;
  if (Array.isArray(lista)) return lista;
  if (Array.isArray(response?.data)) return response.data;
  return [];
};

const possuiDadosValidos = (response) => {
  if (!response) return false;
  if (response?.success === false) return false;
  if (response?.data?.success === false) return false;
  return Array.isArray(response?.data?.data?.data) || Array.isArray(response?.data);
};

const listarPorEntidade = async () => {
  const response = await finMovService.getAll(1, 5000, "", "", null, null, null, "dataMovimento");
  return extrairLista(response);
};

const listarPorView = async (params = []) => {
  const viewNames = [
    "relatorio-movimento-financeiro",
    "4dee0f17-f5a9-42b1-8272-34e2d0d73352",
    "finmov"
  ];

  for (const viewName of viewNames) {
    const response = await viewService.viewRun(viewName, 1, params);
    if (possuiDadosValidos(response)) {
      return extrairLista(response);
    }
  }

  return [];
};

export default {
  async listarMovimentoFinanceiro(filtros = {}) {
    const params = [];

    if (filtros.dataInicio) {
      params.push({ dataType: "String", name: "dataInicio", value: filtros.dataInicio });
    }

    if (filtros.dataFim) {
      params.push({ dataType: "String", name: "dataFim", value: filtros.dataFim });
    }

    if (filtros.fornecedor) {
      params.push({ dataType: "String", name: "fornecedor", value: filtros.fornecedor });
    }

    if (filtros.banco) {
      params.push({ dataType: "String", name: "banco", value: filtros.banco });
    }

    let lista = await listarPorView(params);

    if (!lista.length) {
      lista = await listarPorEntidade();
    }

    return lista.map((linha) => normalizarLinha(linha));
  }
};
